import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    title:{ type: String, default: null },
    url: '/api',
    event: {
      finished: null,
      broadcasting: null,
      url_to: null,
      survey_enabled: null,
      survey: null,
      demo_mode: null
    },
    url_to: null,
    token: null,
    assistant: {
      name: null,
      nickname: null,
      email: null,
      id: null,
      key_id: null,
      remaining_attempts: null,
      exam_approved: false,
      answered_survey: false,
      session_id: null
    },
    event_key_id: null,
  },
  mutations: {
    set_event(state, event) {
      state.event = event
    },
    set_title(state, title) {
      state.title = title
    },
    set_url_to(state, url_to) {
      state.url_to = url_to
    },
    set_event_key_id(state, event_key_id) {
      state.event_key_id = event_key_id
    },
    set_url(state, url) {
      state.url = url
    },
    auth_success(state, item) {
      state.status = 'success'
      state.token = item.token
      state.assistant = item.assistant
    },
  },
  actions: {
    post({ commit }, api) {
      return new Promise((resolve, reject) => {
        axios({ url: this.state.url + api.url, data: api.data, method: 'POST', headers: api.headers, params: api.params })
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err.response.data)
          })
      })
    },
    get_static({ commit }, static_file) {
      return new Promise((resolve, reject) => {
        axios({ url: '/static/' + static_file, method: 'GET' })
          .then(resp => {
            resolve(resp)
          }).catch(err => {
            reject(err.response.data)
          })
      })
    },
    download({ commit }, api) {
      return new Promise((resolve, reject) => {
        axios({ url: this.state.url + api.url, data: api.data, method: api.method, headers: api.headers, responseType: 'blob', params: api.params })
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err.response.data)
          })
      })
    },
    download_by_url({ commit }, param) {
      return new Promise((resolve, reject) => {
        axios({ url: param.url, responseType: 'blob' })
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err.response)
          })
      })
    },
  },
  getters: {
    eventFinished: state => state.event.finished,
    eventBroadcasting: state => state.event.broadcasting,
    urlTo: state => state.url_to,
    isLoggedIn: state => !!state.token,
    assistant: state => state.assistant,
    event: state => state.event,
    eventKeyId: state => state.event_key_id,
    eventUrlTo: state => state.event.url_to,
    isDemo: state => state.event.demo_mode,
    surveyEnabled: state => state.event.survey_enabled,
    eventSurveyId: state => state.event.survey
  },
  modules: {
  }
})